import { Box, Typography, useTheme, TextField } from "@mui/material";
import { tokens } from "../../theme";

import { useState, useEffect } from "react";
import { djangoApi } from "../../utils/axios/axios.utils";
import CircularProgress from '@mui/material/CircularProgress';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import styles from './ajustes-estoque.module.css'
import SemProduto from "../../assets/img/produto-sem-imagem.jpg"
import AjustesEstoquesTable from "../../components/ajustes-estoques";
const AjustesEstoquePage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState();
    const [dataToFilter, setDataToFilter] = useState([]);

    const [moveInventoryData, setMoveInventoryData] = useState([]);


    const MySwal = withReactContent(Swal);

    document.addEventListener('keydown', function (e) {
        const overlay = document.getElementById('image-lightbox');
        const isVisible = overlay && overlay.style.display === 'flex';

        if (isVisible && e.key === 'Escape') {
            e.stopImmediatePropagation();  // critical: block SweetAlert
            e.preventDefault();            // prevent browser default
            overlay.style.display = 'none';
        }
    }, true);  // ← this enables capture phase

    if (!document.getElementById('image-lightbox')) {
        const overlay = document.createElement('div');
        overlay.id = 'image-lightbox';
        overlay.style.cssText = `
            display: none;
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0, 0, 0, 0.95);
            z-index: 20000;
            justify-content: center;
            align-items: center;
        `;
        overlay.innerHTML = `
            <img id="lightbox-img" src="" alt="Imagem em tela cheia" style="max-width: 90%; max-height: 90%;" />
        `;

        overlay.addEventListener('click', () => {
            overlay.style.display = 'none';
        });

        // Esc key handling
        document.addEventListener('keydown', (e) => {
            const isVisible = overlay.style.display === 'flex';
            if (isVisible && e.key === 'Escape') {
                e.stopPropagation();  // prevent SweetAlert from closing
                e.preventDefault();   // prevent default behavior
                overlay.style.display = 'none';
            }
        });

        document.body.appendChild(overlay);
    }

    const showObservationModal = async (selectedItem) => {
        MySwal.fire({
            title: 'Adicionar Saída no Estoque',
            customClass: {
                cancelButton: styles['cancel-button'],
                title: styles['title-saida']
                // confirmButton: styles['confirm-button'],

            },
            html: `
                <style>
                .swal2-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 10px;
                }
                .swal2-table th, .swal2-table td {
                    text-align: left;
                    padding: 6px 10px;
                    border-bottom: 1px solid #ddd;
                }
                .swal2-table th {
                    background-color: #f9f9f9;
                    width: 30%;
                }
                .flex-row {
                    display: flex;
                    gap: 10px;
                    align-items: flex-start;
                    margin-top: 10px;
                }
                .obs-textarea {
                    width: 80%;
                    resize: vertical;
                    height: 100px;
                }
                .quantity-input {
                    width: 20%;
                    min-width: 80px;
                }
                </style>
                <div>
                <div class="${styles.radio_form}" >
                    <label><input type="radio" name="tipoMov" value="saida" checked /> Saída</label>
                    <label style="margin-left: 10px;"><input type="radio" name="tipoMov" value="entrada" /> Entrada</label>
                </div>
                <div class="${styles.mainTable}" >
                    <table class="swal2-table" style="width: 75%" >
                    <tr><th>ID:</th><td>${selectedItem.id_produto}</td></tr>
                    <tr><th>Modelo:</th><td>${selectedItem.model}</td></tr>
                    <tr><th>Tamanho:</th><td>${selectedItem.size || 'N/A'}</td></tr>
                    <tr><th>Valor:</th><td>${selectedItem.value || 'N/A'}</td></tr>
                    <tr><th>Estoque:</th><td>${selectedItem.quantity || 'N/A'}</td></tr>
                    </table>
                    <div style="text-align: center; width: 20%; cursor: pointer">
                        <img id="swal-product-img" src="${selectedItem.imageUrl}" alt="Produto" style="max-height: 150px; border-radius: 12px; object-fit: contain;" 
                            onerror="this.onerror=null; this.src='${SemProduto}';" 
                        />
                    </div>
                </div>

                <div style="display: flex; justify-content: space-between; width: 100%">
                    <div class="flex-row" style="display: flex; gap: 30px; align-items: flex-start; width: 100%;">
                        
                        <!-- Left column: Radio and Quantity -->
                        <div style="display: flex; flex-direction: row; gap: 15px; min-width: 150px;">
                            

                            <!-- Quantity Input -->
                            <div class="quantity-input" style="min-width: 80px; width: 100%;">
                                <label for="quantity" style="margin-bottom: 10px"><strong>Quantidade</strong></label><br/>
                                <input type="number" id="quantity" value="1" min="1" max="${selectedItem.quantity}" style="padding: 5px; width: 50%;" />
                            </div>
                        </div>

                        <!-- Right column: Observação -->
                        <div style="flex: 1;">
                        <label for="obsText"><strong>Observação</strong></label><br/>
                        <textarea id="obsText" class="obs-textarea" rows="4" placeholder="Digite uma observação..." style="width: 100%; resize: vertical;"></textarea>
                        </div>

                    </div>
                    </div>
            `,
            showCancelButton: true,
            width: '850px', // or '80%', '60rem', etc.
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            didOpen: () => {
                const img = document.getElementById('swal-product-img');
                const lightbox = document.getElementById('image-lightbox');
                const lightboxImg = document.getElementById('lightbox-img');

                img?.addEventListener('click', () => {
                    lightboxImg.src = selectedItem.imageUrl;
                    lightbox.style.display = 'flex';
                });
                // Add listener to radio buttons
                document.querySelectorAll('input[name="tipoMov"]').forEach((radio) => {
                    radio.addEventListener('change', (e) => {
                        const selected = e.target.value;
                        const titleEl = document.querySelector('.swal2-title');
                        if (titleEl) {
                            titleEl.textContent = selected === 'entrada'
                                ? 'Adicionar Entrada no Estoque'
                                : 'Adicionar Saída do Estoque';
                            titleEl.classList.remove(styles['title-entrada'], styles['title-saida']);
                            titleEl.classList.add(selected === 'entrada' ? styles['title-entrada'] : styles['title-saida']);
                        }
                    });
                });
            },
            preConfirm: () => {
                const observation = document.getElementById('obsText').value;
                const quantityMove = Number(document.getElementById('quantity').value);
                const tipoMov = document.querySelector('input[name="tipoMov"]:checked')?.value;

                if (!observation) {
                    Swal.showValidationMessage('Por favor, insira uma observação.');
                    return false;
                }

                return {
                    ...selectedItem,
                    observation,
                    quantityMove,
                    tipoMov, // <-- will be either 'saida' or 'entrada'
                };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                const dataToSend = result.value;

                MySwal.fire({
                    title: 'Enviando...',
                    didOpen: async () => {
                        MySwal.showLoading();
                        const params = {
                            ...dataToSend
                        }
                        try {
                            const res = await djangoApi
                                .post("products/register_prods/update_invetary_prods/", params, {
                                    headers: {
                                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                                        "Content-Type": "application/json"
                                    }
                                })
                            console.log('res', res)
                            // Simulated success
                            // const { status, data} = res
                            const { status, data } = res
                            if (status === 201) {
                                if (data?.new_instance) {
                                    setMoveInventoryData(prev => [data.new_instance, ...prev]);
                                }
                                if (data?.dados) {
                                    setDataToFilter((prev) => {
                                        const newQuantity = data.dados.tipoMov === 'saida' ? data.dados.quantity - data.dados.quantityMove : data.dados.quantity + data.dados.quantityMove
                                        const newData = {
                                            ...data.dados,
                                            quantity: newQuantity
                                        }

                                        if (data.dados.content_type__model !== 'aneis') {
                                            const newArrayWithout = prev.filter(
                                                (prevData) =>
                                                    !(prevData.id_produto === data.dados.id_produto &&
                                                        prevData.color === data.dados.color)
                                            );
                                            return [...newArrayWithout, newData];
                                        } else {
                                            const newArrayWithout = prev.filter(
                                                (prevData) =>
                                                    !(prevData.id_produto === data.dados.id_produto &&
                                                        prevData.color === data.dados.color &&
                                                        prevData.size === data.dados.size)
                                            );
                                            return [...newArrayWithout, newData];
                                        }
                                    })
                                }
                                MySwal.fire('Sucesso!', 'Movimentação registrada com sucesso!!', 'success');
                            }
                        } catch (error) {
                            MySwal.fire('Erro!', `Falha ao enviar dados para a API. ${error}}`, 'error');
                        }
                    },
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    showCancelButton: false,
                });
            };
        })
    }


    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length === 6) {
            let getResult = dataToFilter.find((data) => data.id_produto === value);
            console.log('getResults: ', getResult)
            if (getResult) {
                if (getResult.model === 'aneis') {
                    const results = dataToFilter.filter((data) => data.id_produto === value);

                    if (Array.isArray(results) && results.length > 1) {
                        const tableHtml = `
                        <style>
                            table {
                            width: 100%;
                            border-collapse: collapse;
                            text-align: left;
                            }
                            thead {
                            background-color: #f0f0f0;
                            }
                            th, td {
                            padding: 8px 12px;
                            border-bottom: 1px solid #ddd;
                            }
                            tbody tr:nth-child(even) {
                            background-color: #f9f9f9;
                            }
                            tbody tr:hover {
                            background-color: #f1f1f1;
                            }
                            .select-btn {
                            background-color: #1976d2;
                            color: white;
                            border: none;
                            border-radius: 6px;
                            padding: 6px 12px;
                            cursor: pointer;
                            font-size: 14px;
                            transition: background-color 0.3s ease;
                            }
                            .select-btn:hover {
                            background-color: #115293;
                            }
                        </style>
                  <table style="width: 100%; text-align: left; border-collapse: collapse;">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Modelo</th>
                        <th>Tamanho</th>
                        <th>Preço</th>
                        <th>Estoque</th>
                        <th style="text-align: center">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${results
                                .map(
                                    (item, index) => `
                        <tr>
                          <td>${item.id_produto}</td>
                          <td>${item.model}</td>
                          <td>${item.size || 'N/A'}</td>
                          <td>${item.value || 'N/A'}</td>
                          <td>${item.quantity || 'N/A'}</td>
                          <td style="text-align: center">
                            <button
                                onclick="selectItem(${index})"
                                style="
                                background-color: #1976d2;
                                color: white;
                                border: none;
                                border-radius: 6px;
                                padding: 6px 12px;
                                cursor: pointer;
                                font-size: 14px;
                                transition: background-color 0.3s ease;
                                "
                                onmouseover="this.style.backgroundColor='rgba(17,82,147,1.0)'"
                                onmouseout="this.style.backgroundColor='#1976d2'"
                            >
                                Selecionar
                            </button>
                            </td>
                        </tr>`
                                )
                                .join('')}
                    </tbody>
                  </table>
                `;

                        MySwal.fire({
                            title: 'Selecione um produto abaixo:',
                            html: tableHtml,
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Cancelar',
                            customClass: {
                                cancelButton: styles['cancel-button']
                            },
                            width: '850px', // or '80%', '60rem', etc.
                            didOpen: () => {
                                results.forEach((item, index) => {
                                    document
                                        .querySelector(`button[onclick="selectItem(${index})"]`)
                                        ?.addEventListener('click', () => {
                                            showObservationModal(results[index]);
                                        });
                                });
                            }
                        });
                    } else {
                        showObservationModal(results[0]);
                    }
                } else {
                    // MySwal.fire("Encontrado!", JSON.stringify(getResult, null, 2), "success");
                    showObservationModal(getResult);
                }

                setSearchQuery("");
            } else {
                MySwal.fire("Ops!!", `Produto não encontrado: ${value}`, "error");
            }
        }
    };

    useEffect(() => {
        setIsLoading(true)
        const fetchData = async () => {
            try {
                const headers = {
                    Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                    "Content-Type": "application/json"
                };

                const [res1, res2] = await Promise.all([
                    djangoApi.get("products/register_prods/get_all_kitprods_open/", { headers }),
                    djangoApi.get("products/register_prods/get_prods_ajustes_preco/", {
                        headers,
                        params: {
                            should_return_other_prods: true, // 👈 Add your query param here
                            include_zero: true
                        }
                    })
                ]);

                // Pegando os dados dos dois
                const data1 = res1.data?.dados?.data || [];
                // console.log('data1', data1)
                const estoqueRes = res2.data?.dados
                // console.log('estoqueres', estoqueRes)
                const flattenGroupedData = Object.entries(estoqueRes).flatMap(
                    ([key, items]) =>
                        items.map(item => ({
                            ...item,
                            model: key
                        }))
                );
                const data2 = flattenGroupedData.map((data) => {

                    return (
                        {
                            "sell_price": data?.charged_price,
                            "kit__kit_number": 0,
                            "kit__pay_date": '',
                            "kit__seller__nome": "Pitaya Joias",
                            "content_type__model": data?.model,
                            "quantity": data?.quantity_available,
                            "pk": data?.pk,
                            "product_id_produto": data?.id_produto,
                            "product_tamanho": data?.tamanho ? data?.tamanho : 0,
                            "product_id_produto_color": data?.color__color,
                            "imageUrl": data?.imageUrl
                        }
                    )
                })
                const changedPrice = res2?.data?.changed_prods
                // console.log('changed Prices : ', changedPrice)
                // Combinando
                const combined = [...data2, ...data1];

                const finalArray = combined.map((data) => {
                    return (
                        {
                            ...data,
                            pk: data?.product_id_produto_pk ? data?.product_id_produto_pk : data.pk,
                            value: data.sell_price,
                            id_produto: data.product_id_produto,
                            size: data.product_tamanho,
                            color: data.product_id_produto_color,
                            quantity: data.quantity,
                            model: data.content_type__model,
                            imageUrl: data.imageUrl,
                        }
                    )
                })

                // console.log('finakArray: ', finalArray)

                const mergedArray = finalArray.reduce((acc, item) => {
                    const sizeAdjust = item.size ? item.size : 0
                    let key = ''
                    if (item.model === 'aneis') {
                        // key = `${item.id_produto}-${sizeAdjust}-${item.color}-${item.pk}`;
                        key = `${item.id_produto}-${sizeAdjust}-${item.color}`;
                    } else {
                        key = `${item.id_produto}-${item.color}`;
                    }

                    if (!acc[key]) {
                        // Make sure quantity is a number when first cloning
                        acc[key] = { ...item, quantity: Number(item.quantity) };
                    } else {
                        // Add up as numbers, not strings
                        acc[key].quantity += Number(item.quantity);
                    }


                    return acc;
                }, {});

                // Convert the object back to an array
                const combinedArray = Object.values(mergedArray);


                // console.log('combined data', combinedArray)

                // Step 1: Create a map for fast lookup
                const serverMap = Object.fromEntries(
                    changedPrice.map((item) => [item.id_produto, item])
                );

                // Step 2: Update the original array if matches found
                const updatedArray = combinedArray.map((item) => {
                    const match = serverMap[item.id_produto];
                    if (match) {
                        return {
                            ...item,
                            value: parseFloat(match.price),
                            quantity: match.quantity
                        };
                    }
                    return item;
                });

                setDataToFilter(updatedArray)

            } catch (error) {
                console.error("Erro ao buscar dados:", error);
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const getMoveData = async () => {
            try {
                const headers = {
                    Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                    "Content-Type": "application/json",
                };

                const response = await djangoApi.get(
                    "products/move_inventory/get_all_move_inventory/",
                    { headers }
                );

                setMoveInventoryData(response.data.data);
                console.log("Move Inventory:", response.data.data);
            } catch (error) {
                console.error("Error fetching move inventory:", error);
            }
        };

        getMoveData();
    }, []);

    // const getMoveData = async () => {
    //     try {
    //         const headers = {
    //             Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
    //             "Content-Type": "application/json",
    //         };

    //         const response = await djangoApi.get(
    //             "products/move_inventory/get_all_move_inventory/",
    //             { headers }
    //         );

    //         setMoveInventoryData(response.data.data);
    //         console.log("Move Inventory:", response.data.data);
    //     } catch (error) {
    //         console.error("Error fetching move inventory:", error);
    //     }
    // };

    if (isLoading) {
        return <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',  // Ensure it spans the entire width
                height: '100vh', // Use full viewport height for centering
            }}
        ><CircularProgress /></Box>
    }

    return (
        <Box
            sx={{
                marginTop: '60px',
                paddingLeft: '20px'
            }}
        >
            <Typography sx={{ color: 'whitesmoke' }} variant="h6">
                Ajustes de Estoque
            </Typography>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginRight: '20px',
                position: 'sticky',
                top: 50,
                zIndex: 10,
                paddingTop: '10px',
                paddingBottom: '20px',
                backgroundColor: colors.pink[500]
            }}>

                <Box sx={{ width: "100%", display: "flex", flexDirection: 'column', justifyContent: "center" }}>

                    <TextField
                        variant="standard"
                        placeholder="Insira um ID"
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                        inputProps={{ maxLength: 6 }}
                        sx={{
                            width: "200px",
                            marginRight: "10px",
                            '& .MuiInput-underline:before': {
                                borderBottomColor: 'whitesmoke', // default
                            },
                            '& .MuiInput-underline:hover:before': {
                                borderBottomColor: 'rgba(153,153,153,0.2)', // hover
                            },
                            '& .MuiInput-underline:after': {
                                borderBottomColor: 'rgba(204,204,204,0.5)', // focus
                            },

                        }}
                    />
                    <Typography sx={{ color: colors.primary[100], padding: '2px', paddingTop: '5px' }} fontSize={"0.8em"}>
                        Faça uma nova movimentação
                    </Typography>
                </Box>
            </Box>
            <AjustesEstoquesTable
                moveInventoryData={moveInventoryData}
            />
        </Box>
    );
}

export default AjustesEstoquePage;